import React, {useMemo, useState} from 'react';
import PropTypes from 'prop-types';
import {Checkbox, Dropdown, Space} from 'antd';
import {
  StyledTableSettingsButton,
  StyledTableSettingsButtonDivider,
  StyledTableSettingsButtonSpace,
  StyledTableSettingsButtonDropdownSpace
} from './StyledTableSettingsButton';
import {SettingsIcon} from '../../../../icons';

const TableSettingsButton = ({
  buttonProps = {},
  children,
  defaultSelectedKeys = [],
  options,
  onChange,
}) => {
  const [selectedItems, setSelectedItems] = useState(defaultSelectedKeys);

  const menu = useMemo(() => ({
    items: options,
    multiple: true,
    selectable: true
  }), [options]);

  const handleOnCheck = (e, option) => {
    const {checked} = e.target;
    let items = checked ? [...selectedItems, option] : selectedItems.filter(o => o !== option);
    setSelectedItems(items);
    onChange && onChange(items);
  }

  const dropdownRender = () => {
    return (
      <StyledTableSettingsButtonDropdownSpace direction='vertical' size={0}>
        {options.map((option, index) => {
          const {value, label} = option;
          return (
            <Space key={index}>
              <Checkbox
                checked={selectedItems.includes(value)}
                onChange={(e) => handleOnCheck(e, value)}
              >
                {label}
              </Checkbox>
            </Space>
          )
        })}
      </StyledTableSettingsButtonDropdownSpace>
    );
  }

  return (
    <StyledTableSettingsButtonSpace size={0} split={<StyledTableSettingsButtonDivider type='vertical' />}>
      <Dropdown
        popupRender={dropdownRender}
        menu={menu}
        placement='bottomRight'
        trigger='click'
      >
        <StyledTableSettingsButton
          icon={<SettingsIcon />}
          size='large'
          type='default'
          {...buttonProps}
        />
      </Dropdown>
      {children}
    </StyledTableSettingsButtonSpace>
  )
}

TableSettingsButton.propTypes = {
  buttonProps: PropTypes.object,
  children: PropTypes.node,
  defaultSelectedKeys: PropTypes.arrayOf(PropTypes.string),
  options: PropTypes.array,
  onChange: PropTypes.func
}

export default TableSettingsButton;
